import { io, Manager } from "socket.io-client";

export function connectSocket() {
  return io(window["VUE_APP_SOCKET_URL"], {
    reconnectionDelayMax: 1000,
  });
}

let manager = null;

function getManagerInstance(baseURL) {
  if (!manager) {
    manager = new Manager(baseURL, {
      transports: ["websocket"],
      reconnectionDelayMax: 1000,
    });
  }
  return manager;
}

export function connectSocketChatMeLib(baseURL, namespace, jwtToken) {
  const manager = getManagerInstance(baseURL);
  const namespaceSocket = manager.socket(namespace, {
    auth: {
      token: jwtToken,
    },
  });
  return namespaceSocket;
}

export function disconnectManager() {
  if (manager) {
    manager.disconnect();
    manager = null;
  }
}
